export const fr = {
  // Navigation (French)
  explore: 'Explorer',
  search: 'Rechercher',
  create: 'Créer un Post',
  messages: 'Messages',
  notifications: 'Notifications',
  settings: 'Paramètres',
  profile: 'Profil',
  logout: 'Déconnexion',
  home: 'Accueil',
  
  // Authentication
  signin: 'Se connecter',
  signup: 'S\'inscrire',
  login: 'Se connecter',
  register: 'S\'inscrire',
  email: 'E-mail',
  password: 'Mot de passe',
  confirmPassword: 'Confirmer le mot de passe',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  forgotPassword: 'Mot de passe oublié?',
  alreadyHaveAccount: 'Déjà un compte? Se connecter',
  dontHaveAccount: 'Pas de compte? S\'inscrire',
  
  // Posts & Content
  recent: 'Récent',
  trending: 'Tendances',
  popular: 'Populaire',
  like: 'J\'aime',
  likes: 'J\'aime',
  comment: 'Commentaire',
  comments: 'Commentaires',
  share: 'Partager',
  delete: 'Supprimer',
  edit: 'Modifier',
  post: 'Publication',
  posts: 'Publications',
  title: 'Titre',
  content: 'Contenu',
  tags: 'Étiquettes',
  noBlogsFound: 'Aucun blog trouvé. Essayez de chercher autre chose ou créez le premier!',
  
  // AI Assistant
  quickActions: 'Actions rapides',
  writeCaption: 'ÉCRIRE UNE LÉGENDE',
  suggestTopics: 'SUGGÉRER DES SUJETS',
  improveContent: 'AMÉLIORER LE CONTENU',
  creativeIdeas: 'IDÉES CRÉATIVES',
  clearChat: 'EFFACER LE CHAT',
  aiWritingAssistant: 'Assistant d\'écriture IA',
  poweredByGroq: 'Alimenté par GROQ AI',
  aiGreeting: 'Salut! Je suis votre assistant d\'écriture IA. Je peux vous aider à créer du contenu engageant, écrire des légendes, suggérer des sujets de publication et améliorer votre écriture. Sur quoi aimeriez-vous travailler aujourd\'hui?',
  askMeToHelp: 'Demandez-moi de l\'aide avec le contenu, les légendes, les sujets ou l\'écriture...',
  aiThinking: 'L\'IA réfléchit...',
  
  // Chat & Messages
  chat: 'Chat',
  noConversationsYet: 'Pas encore de conversations',
  ideafluxChat: 'Chat IdeaFlux',
  typeMessage: 'Tapez un message...',
  sendMessage: 'Envoyer le message',
  connectingToChat: 'Connexion au chat...',
  
  // Notifications
  noNotificationsYet: 'Pas encore de notifications.',
  markAllRead: 'Tout marquer comme lu',
  clearAll: 'Tout effacer',
  
  // Settings
  accountSettings: 'Paramètres du compte',
  displayName: 'Nom d\'affichage',
  emailAddress: 'Adresse e-mail',
  languagePreference: 'Préférence de langue',
  privacySecurity: 'Confidentialité et sécurité',
  notificationPreferences: 'Préférences de notification',
  allowDirectMessages: 'Autoriser les messages directs',
  letOthersMessage: 'Permettre aux autres utilisateurs de vous envoyer des messages privés',
  likesOnPosts: 'J\'aime sur les publications',
  commentsOnPosts: 'Commentaires sur les publications',
  newFollowers: 'Nouveaux abonnés',
  mentions: 'Mentions',
  save: 'Sauvegarder',
  deleteAccount: 'Supprimer le compte',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'Être notifié quand quelqu\'un',
  likesYourPosts: 'aime vos publications',
  commentsOnYourPosts: 'commente vos publications',
  followsYou: 'vous suit',
  mentionsYou: 'vous mentionne',
  chooseNotifications: 'Choisissez quelles notifications vous voulez recevoir',
  controlWhoInteracts: 'Contrôlez qui peut interagir avec vous',
  manageAccountInfo: 'Gérez les informations et préférences de votre compte',
  emailCannotBeChanged: 'L\'e-mail ne peut pas être modifié pour des raisons de sécurité',
  
  // Common
  loading: 'Chargement...',
  cancel: 'Annuler',
  update: 'Mettre à jour',
  submit: 'Soumettre',
  back: 'Retour',
  next: 'Suivant',
  previous: 'Précédent',
  online: 'En ligne',
  offline: 'Hors ligne',
  
  // Profile
  editProfile: 'MODIFIER LE PROFIL',
  noBioYet: 'Pas encore de bio.',
  followers: 'Abonnés',
  following: 'Abonnements',
  recentActivity: 'Activité récente',
  noPostsYet: 'Pas encore de publications',
  shareFirstPost: 'Partagez votre première publication!',
  bio: 'Bio',
  dateOfBirth: 'Date de naissance',
  follow: 'Suivre',
  unfollow: 'Ne plus suivre',
  
  // Search
  discover: 'Découvrir',
  findPeopleStories: 'Trouvez des personnes, des histoires et des idées qui vous importent',
  searchByName: 'Rechercher par nom, titre ou #tag...',
  searchResults: 'Résultats de recherche',
  noResultsFound: 'Aucun résultat trouvé',
  peopleFound: 'Personnes trouvées',
  
  // Settings - Additional keys
  enterDisplayName: 'Entrez votre nom d\'affichage',
  saving: 'Sauvegarde...',
  confirmDeleteAccount: 'Êtes-vous sûr de vouloir supprimer votre compte? Cela ne peut pas être annulé.',
  accountDeletedSuccessfully: 'Compte supprimé avec succès.',
  errorDeletingAccount: 'Erreur lors de la suppression du compte. Veuillez réessayer.',
  settingsSavedSuccessfully: 'Paramètres sauvegardés avec succès!',
  failedToSaveSettings: 'Échec de la sauvegarde des paramètres. Veuillez réessayer.',
  
  // Form component
  pleaseSignInToCreate: 'Veuillez vous connecter pour créer une publication.',
  titleRequired: 'Le titre est requis pour publier une publication.',
  contentRequired: 'Le contenu de l\'histoire est requis pour publier une publication.',
  contentTooShort: 'Le contenu de l\'histoire doit faire au moins 10 caractères.',
  postUpdatedSuccessfully: 'Publication mise à jour avec succès!',
  postPublishedSuccessfully: 'Publication publiée avec succès!',
  pleaseSignInToCreateBlogs: 'Veuillez vous connecter pour créer vos propres blogs IdeaFlux.',
  enterEngagingTitle: 'Entrez un titre engageant...',
  story: 'Histoire',
  writeYourMasterpiece: 'Écrivez votre chef-d\'œuvre...',
  addTags: 'Ajouter des étiquettes...',
  add: 'Ajouter',
  publishPost: 'Publier la publication',
  
  // Post component
  linkCopiedToClipboard: 'Lien copié dans le presse-papiers! Compteur de partages mis à jour.',
  youAndOthers: 'Vous et {{count}} autres',
  unknownUser: 'Utilisateur inconnu',
  noImage: 'Aucune image',
  deletePost: 'Supprimer la publication',
  confirmDeletePost: 'Êtes-vous sûr de vouloir supprimer cette publication?',
};